import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../utils/auth.ts";
import Layout from "../../components/Layouts/Layout.tsx";
import GeneralSettingsContent from "../../components/Settings/GeneralSettingsContent.tsx";

export const Route = createFileRoute('/settings/general')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <GeneralSettingsContent />
    </Layout>
  );
}
